import Checkbox from '@mui/material/Checkbox';
import { useDispatch, useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import * as IssuesV2Store from '../../../redux/issuesV2';

/**
 * IssuesSelectAllCheckbox is the checkbox at the top of the UI
 * which is responsible for "bulk selecting" the issues.
 */
const IssuesSelectAllCheckbox: VoidFunctionComponent = () => {
  const dispatch = useDispatch();
  const checkboxState = useSelector(IssuesV2Store.selectors.getBulkCheckboxState);
  const isComparisonModeOn = useSelector(IssuesV2Store.selectors.getComparisonMode);

  if (isComparisonModeOn) {
    return null;
  }

  return (
    <Checkbox
      className="issues-inbox__header__bulk-checkbox"
      indeterminate={checkboxState === 'indeterminate'}
      checked={checkboxState === 'checked'}
      onChange={() => dispatch(IssuesV2Store.actions.toggleSelectAllOnPage())}
      data-test-id="issues-inbox-checkbox-select-all"
    />
  );
};

export default IssuesSelectAllCheckbox;
